// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/shared/actionCreator";
import { GetSpecialContactTypes } from "@modules/shared/constants/actions";

type ListResponse<T> = $Exact<{
  content: T,
  paginations: any,
}>;

type ListRequest = $Exact<{
  clientId: string,
}>;

export function* onGetSpecialContactTypes({
  payload,
}: Action<ListRequest>): Generator<*, void, { data: ListResponse<Array<Object>> }> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${payload.clientId}/special-contact-type`,
    );

    yield put(actionCreators.GetSpecialContactTypesSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetSpecialContactTypesError(e.response));
  }
}

export function* SpecialContactTypesSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetSpecialContactTypes, onGetSpecialContactTypes)]);
}

export default SpecialContactTypesSagas;
